export const shouldDisplaySchemaConfirmationModal = (schema?: string, currentSchema?: string) => {
  if (schema && currentSchema) {
    return schema !== currentSchema;
  }

  return false;
};
